<template>
  <v-container fluid class="vendor-list-page pa-0">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editVendor="selectedvendor"
    />

    <v-card :loading="loading" outlined class="vendor-list-card">
      <div class="vendor-list-header">
        <div class="vendor-title-wrap">
          <v-btn icon small class="mr-2" @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div>
            <div class="page-title">Vendor</div>
            <div class="page-subtitle">
              {{ totalItems }} vendor{{ totalItems === 1 ? "" : "s" }} found
            </div>
          </div>
        </div>

        <v-btn
          v-if="checkRightStatus(3)"
          small
          rounded
          color="primary"
          dark
          @click="add"
        >
          <v-icon left small>mdi-plus</v-icon>
          New Vendor
        </v-btn>
      </div>

      <div class="vendor-filter-bar">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search vendor"
          single-line
          hide-details
          clearable
          class="vendor-search"
        />
      </div>

      <v-card-text class="pa-4">
        <div class="summary-row mb-4">
          <div class="summary-box">
            <div class="summary-label">List Balance</div>
            <div class="summary-value">{{ balance | currency }}</div>
          </div>

          <div class="summary-box">
            <div class="summary-label">Result Balance</div>
            <div class="summary-value">{{ fullBalance | currency }}</div>
          </div>
        </div>

        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="vendors"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          class="vendor-table"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer vendor-row">
              <td class="text-left font-weight-bold" @click="viewProfile(item)">
                <span v-html="$highlight(item.name || '', safeSearch)"></span>
              </td>

              <td class="text-left" @click="viewProfile(item)">
                <span v-html="$highlight(item.phoneNumber || '--', safeSearch)"></span>
              </td>

              <td class="text-left" @click="viewProfile(item)">
                <span v-html="$highlight(item.email || '--', safeSearch)"></span>
              </td>

              <td class="text-right font-weight-bold" @click="viewProfile(item)">
                {{ item.balance | currency }}
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item
                      v-if="checkRightStatus(19)"
                      @click="viewProfile(item)"
                    >
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>

                    <v-divider />

                    <v-list-item
                      v-if="checkRightStatus(19)"
                      @click="edit(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="checkRightStatus(11)"
                      @click="deletevendor(item)"
                    >
                      <v-list-item-title class="red--text">
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <template v-slot:body.append="{ headers }" v-if="vendors.length > 0">
            <tr class="table-total-row">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                List Total
              </td>

              <td class="text-right font-weight-bold">
                {{ balance | currency }}
              </td>

              <td></td>
            </tr>

            <tr class="table-result-row">
              <td
                :colspan="headers.length - 2"
                class="text-right font-weight-bold"
              >
                Result Total
              </td>

              <td class="text-right font-weight-bold">
                {{ fullBalance | currency }}
              </td>

              <td></td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import vendorService from "../service";
import { mapGetters } from "vuex";
import _ from "lodash";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "vendor-list",

  components: {
    Create,
    Edit,
  },

  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedvendor: null,
      balance: 0,
      fullBalance: 0,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Phone Number",
          align: "left",
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: "Email Address",
          value: "email",
          sortable: true,
        },
        {
          text: "Balance",
          value: "balance",
          align: "right",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      vendors: [],
      search: "",
      loading: true,
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },

  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),

    safeSearch() {
      return (this.search || "").toLowerCase();
    },
  },

  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },

    search: _.debounce(function () {
      this.options.page = 1;
      this.getList();
    }, 400),
  },

  created() {
    this.getList();
    document.title = "smplsale - Vendor List";
  },

  methods: {
    viewProfile(val) {
      this.$router.push({ path: `/inventory/vendor/${val.id}/profile` });
    },

    add() {
      this.createDialog = true;
    },

    getList() {
      this.loading = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const limit = itemsPerPage || 10;
      const offset = ((page || 1) - 1) * limit;

      const where = {
        limit,
        offset,
        sortBy: sortBy && sortBy.length ? sortBy[0] : "name",
        sortDesc: sortDesc && sortDesc.length ? sortDesc[0] : false,
      };

      if (this.search) {
        where.search = this.search;
      }

      return vendorService
        .getAll(where)
        .then((response) => {
          this.totalItems = Number(response.count || 0);
          this.vendors = response.data || [];
          this.balance = this.vendors.reduce((sum, row) => {
            return sum + Number(row.balance || 0);
          }, 0);
          this.fullBalance = Number(
            response.totals && response.totals.balance
              ? response.totals.balance
              : 0
          );
          return response;
        })
        .catch((error) => {
          console.error("vendor getList failed", error);
          this.vendors = [];
          this.totalItems = 0;
          this.balance = 0;
          this.fullBalance = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    edit(vendor) {
      this.selectedvendor = vendor;
      this.editDialog = true;
    },

    deletevendor(vendor) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          vendorService.delete(vendor.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Vendor has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.vendor-list-page {
  background: #f8fafc;
}

.vendor-list-card {
  border-radius: 20px;
  background: #ffffff;
}

.vendor-list-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.vendor-title-wrap {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.vendor-filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.vendor-search {
  max-width: 340px;
  min-width: 260px;
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 220px));
  gap: 12px;
}

.summary-box {
  background: #f8fafc;
  border-radius: 16px;
  padding: 14px;
}

.summary-label {
  font-size: 12px;
  color: #64748b;
}

.summary-value {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  margin-top: 4px;
}

.vendor-table {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.vendor-row:hover {
  background: #f8fafc;
}

.table-total-row {
  background: #f8fafc;
}

.table-result-row {
  background: #eef2ff;
}

@media (max-width: 600px) {
  .vendor-search {
    max-width: 100%;
    min-width: 100%;
  }

  .summary-row {
    grid-template-columns: 1fr;
  }
}
</style>
